import { rem } from 'polished';

/**
 * Util function for font body CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontBody(fontSize = 12) {
  return `
    font-family: var(--bombas-font);
    font-size: ${rem(fontSize)};
    font-weight: 400;
    line-height: 1.33em;
    letter-spacing: 0;
  `;
}

/**
 * Util function for font display CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontDisplay(fontSize = 16) {
  return `
    font-family: var(--display-font);
    font-size: ${rem(fontSize)};
    font-weight: 800;
    line-height: 0.8em;
    letter-spacing: 0;
  `;
}

/**
 * Util function for font title CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontTitle(fontSize = 16) {
  return `
    font-family: var(--bombas-font);
    font-size: ${rem(fontSize)};
    font-weight: 800;
    line-height: 1.15em;
    letter-spacing: 0;
  `;
}

/**
 * Util function for font title-light CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontTitleLight(fontSize = 16) {
  return `
    font-family: var(--bombas-font);
    font-size: ${rem(fontSize)};
    font-weight: 700;
    line-height: 1.15em;
    letter-spacing: 0;
  `;
}

/**
 * Util function for font accent CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontAccent(fontSize = 16) {
  return `
    font-family: var(--accent-font);
    font-size: ${rem(fontSize)};
    font-weight: 300;
    line-height: 1.15em;
    letter-spacing: 0;
  `;
}
